<template>

<b-container>
  <b-form-row>
    <b-col cols="2">
      <label>Identificador
        <b-form-input v-model="project.codeId"/>
      </label>
    </b-col>
    <b-col cols="2">
      <label>Año
        <b-form-input type="number" v-model.number="project.year"/>
      </label>
    </b-col>
    <b-col>
      <label>Título
        <b-form-input v-model="project.title"/>
      </label>
    </b-col>
    <b-col cols="3">
      <label>Estado
        <b-form-select v-model="project.status" :options="statusOptions"/>
      </label>
    </b-col>
  </b-form-row>
  <b-form-row>
    <b-col cols="4">
      <model-select v-model="selectedClient" :model-request="loadClients" label="Cliente" model-label="name" placeholder="Seleccionar Cliente"/>
    </b-col>
    <b-col>
      <label>Responsables del Proyecto
        <multiselect @search-change="searchUsers" :internal-search="false" :loading="loadingUsers" v-model="selectedUsers" :options="users" multiple
                     label="name" track-by="id" :hide-selected="true" placeholder="Escriba para buscar operarios" selectLabel="Seleccionar"
                     selectedLabel="Seleccionado" deselectLabel="Eliminar">
          <span slot="noResult">No se ha encontrado ningún Operario</span>
        </multiselect>
      </label>
    </b-col>
  </b-form-row>
</b-container>

</template>

<script>

import api from '@/api/api'
import {debounce} from 'lodash'
import ModelSelect from '@/components/common/ModelSelect'

export default {
  name: 'ProjectForm',
  components: {ModelSelect},
  model: {prop: 'project'},
  props: {
    project: {type: Object, required: true},
    client: {type: Object, default: null},
    managers: {type: Array, default: null}
  },
  created() {
    this.loadUsers()
  },
  data() {
    return {
      selectedClient: null,
      users: [],
      selectedUsers: [],
      loadingUsers: false,
      statusOptions: [
        {text: 'Activado', value: 'ACTIVATED'},
        {text: 'Desactivado', value: 'DEACTIVATED'}
      ]
    }
  },
  watch: {
    client(client) {
      this.selectedClient = client && {...client}
    },
    selectedClient(client) {
      if (client) {
        this.project.clientId = client.id
      }
    },
    managers(value) {
      this.selectedUsers = value && value.slice()
    },
    selectedUsers(users) {
      this.project.managerIdList = users.map(user => user.id)
    }
  },
  methods: {
    emptySelects() {
      this.selectedClient = null
      this.selectedUsers = []
    },
    loadClients(name = null) {
      return api.client.index({name, size: 100, sort: 'name'}).then(paginator => paginator.content)
    },
    searchUsers: debounce(function(name) {
      this.loadingUsers = true
      this.loadUsers(name).finally(() => { this.loadingUsers = false })
    }, 1000),
    loadUsers(name = null) {
      return api.appUser.index({name, size: 100, sort: 'name'}).then(paginator => { this.users = paginator.content })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/project/ProjectForm.vue